<!-- 设备详情 折线图 -->
<template>
  <div>
    <div class="line-wrapper"  style="position: relative">
      <div class="noDateShow" v-if="noDateShow">暂无数据</div>
      <div class="line-content" :id="id"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["height", "chartOption"],
  data() {
    return {
      id: this.uuid(),
      noDateShow:true,
    };
  },
  computed: {},
  created() {},
  watch: {
    chartOption: function (newV) {
      console.log(newV,"noDateShow")
      if(newV.series[0].data.length==0){
        this.noDateShow=true
      }else{
        this.noDateShow=false
      }
        const echarts = require("echarts");
        this.myChart = echarts.init(document.getElementById(this.id));
        this.setChart();
    },
  },
  mounted() {
    //console.log("line mounted");
    // const echarts = require("echarts");
    // this.myChart = echarts.init(document.getElementById(this.id));
    // this.setChart();
  },
  methods: {
    setChart() {
      const option =Object.assign(
        {
          color: ["#4facf9", "#e86b59"],
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              },
              // formatter: '{b}</br>{a}: {c} KM'
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              xAxisIndex: [0],
              start: 100-(this.chartOption || {}).dataZoomEnd || 30,
              end: 100, //dataZoomEnd展示百分比
              height: 8,
              handleSize: 0,
              showDetail: false,
              showDataShadow: false,
              bottom: 0,
              backgroundColor: "#e4e3e8",

              handleStyle: {
                borderWidth: 0,
                color: "#c0c0c8",
              },
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
        },
        this.chartOption
      );
      //console.log(option);
      this.myChart.setOption(option);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped="">
.line-wrapper{
  height: 500px;
  width: 1400px;
  // height: 100%;
  .noDateShow{
  height: 500px;
  width: 1300px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
  z-index: 100;
  text-align: center;
  line-height: 400px;
}
  .line-content {
  height: 500px;
  width: 1400px;
}
}

</style>